import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { jsx } from 'react/jsx-runtime';
import { createApiEntityColumns } from './api-entity-columns';

// Overrides plugin-api-docs's provided-apis and consumed-apis entity cards -
// same match-by-id technique as modules/serviceGroupCard and modules/signIn:
// a make() with a given name registered under pluginId 'api-docs' produces
// the id `entity-card:api-docs/<name>`, the same id the stock cards register
// under. Safe as a full replacement (unlike page:catalog) because nothing
// else attaches to an entity-card's output - there's no `inputs` wiring to
// preserve here.
const providedApisCard = EntityCardBlueprint.make({
  name: 'provided-apis',
  params: {
    filter: { kind: 'component' },
    loader: async () => {
      const { ProvidedApisCard } = await import('@backstage/plugin-api-docs');
      return jsx(ProvidedApisCard, { columns: createApiEntityColumns() });
    },
  },
});

const consumedApisCard = EntityCardBlueprint.make({
  name: 'consumed-apis',
  params: {
    filter: { kind: 'component' },
    loader: async () => {
      const { ConsumedApisCard } = await import('@backstage/plugin-api-docs');
      return jsx(ConsumedApisCard, { columns: createApiEntityColumns() });
    },
  },
});

export const apiDocsColumnsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [providedApisCard, consumedApisCard],
});
